import { SurveyElement, SurveyModel } from "survey-core";

export const registerResponsiveStyles = () => {
  const prototype = SurveyElement.prototype as any;

  prototype.calcRootStyle = function (this: any) {
    const style: Record<string, any> = {};
    let _width: number | undefined;

    // Handle column-based layouts (when parent has specific column widths)
    if (this.parent) {
      const columns = this.parent.getColumsForElement(this);
      _width = columns.reduce(
        (sum: number, col: any) => col.effectiveWidth + sum,
        0,
      );
      if (_width && _width !== 100) {
        style["flexGrow"] = 1;
        style["flexShrink"] = 0;
        style["flexBasis"] = _width + "%";
        style["minWidth"] = 0;
        style["maxWidth"] = this.maxWidth;
      }
    }

    if (Object.keys(style).length === 0) {
      let minWidth = "" + this.minWidth;

      if (minWidth && minWidth !== "auto") {
        // Apply widthScale if using pixel values
        if (minWidth.indexOf("px") !== -1 && this.survey) {
          const survey = this.survey as SurveyModel;
          const minWidthNum = parseFloat(minWidth.replace("px", ""));
          if (!isNaN(minWidthNum) && survey.widthScale) {
            minWidth = "" + (minWidthNum * survey.widthScale) / 100 + "px";
          }
        }
      }

      if (this.allowRootStyle && this.renderWidth) {
        style["flexGrow"] = 1;
        // Use minWidth as flexBasis instead of renderWidth (e.g., 50%)
        style["flexBasis"] = minWidth && minWidth !== "auto" ? minWidth : "0";
        // Allow elements to shrink below content width so that
        // non-wrapping labels don't inflate the flex item's minimum size.
        style["minWidth"] = 0;
        style["maxWidth"] = this.maxWidth || "100%";
      }
    }

    return style;
  };
};
